(() => {
  const roots = document.querySelectorAll('[data-topshelf-wishlist-page]');
  if (!roots.length) return;

  const getVariantId = (value) => String(value || '').split('/').pop();

  const parseJson = async (response) => {
    const text = await response.text();
    if (!text) return null;

    try {
      return JSON.parse(text);
    } catch (_) {
      return {message: text};
    }
  };

  roots.forEach((root) => {
    const addButton = root.querySelector('[data-wishlist-add-selected]');
    const removeSelectedButton = root.querySelector('[data-wishlist-remove-selected]');
    const selectedCount = root.querySelector('[data-wishlist-selected-count]');
    const wishlistCount = root.querySelector('[data-wishlist-count]');
    const emptyState = root.querySelector('[data-wishlist-empty]');
    const grid = root.querySelector('[data-wishlist-grid]');
    const endpoint = root.dataset.wishlistEndpoint;
    const token = root.dataset.wishlistToken;
    const customerId = root.dataset.customerId;
    const customerEmail = root.dataset.customerEmail;
    const customerFirstName = root.dataset.customerFirstName;
    const customerLastName = root.dataset.customerLastName;

    const getCards = () => Array.from(root.querySelectorAll('[data-wishlist-card]'));
    const getCheckedBoxes = () =>
      Array.from(root.querySelectorAll('[data-wishlist-select]:checked'));
    const getCheckedAvailableBoxes = () =>
      getCheckedBoxes().filter((checkbox) => !checkbox.hasAttribute('data-wishlist-unavailable'));

    const updateHeaderWishlistCount = (count) => {
      document.querySelectorAll('.kith-menu-wishlist-bubble').forEach((bubble) => {
        bubble.textContent = count > 99 ? '99+' : String(count);
        bubble.classList.toggle('visually-hidden', count === 0);
      });

      window.__topshelfWishlistCount = count;
    };

    const updateSelection = () => {
      const checked = getCheckedBoxes();
      const checkedAvailable = getCheckedAvailableBoxes();

      if (addButton) {
        addButton.disabled = checkedAvailable.length === 0;
      }

      if (removeSelectedButton) {
        removeSelectedButton.disabled = checked.length === 0;
      }

      if (selectedCount) {
        selectedCount.textContent = checked.length
          ? `${checked.length} selected`
          : 'Select items to remove or add to cart';
      }
    };

    const updateWishlistCount = () => {
      if (!wishlistCount) return;

      const count = getCards().length;
      wishlistCount.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
      updateHeaderWishlistCount(count);
    };

    const updateEmptyState = () => {
      const hasCards = getCards().length > 0;
      if (emptyState) emptyState.hidden = hasCards;
      if (grid) grid.hidden = !hasCards;
      updateWishlistCount();
      updateSelection();
    };

    const removeWishlistItem = async (variantId) => {
      if (!endpoint || !token || !customerId) return;

      const response = await fetch(`${endpoint}/items`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Wishlist-Token': token,
        },
        body: JSON.stringify({
          customer: {
            id: customerId,
            email: customerEmail,
            first_name: customerFirstName,
            last_name: customerLastName,
          },
          variant_id: variantId,
        }),
      });
      const data = await parseJson(response);

      if (!response.ok || data?.ok === false) {
        throw new Error(data?.message || 'Unable to remove selected items.');
      }
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-wishlist-select]')) updateSelection();
    });

    removeSelectedButton?.addEventListener('click', async () => {
      const checkedBoxes = getCheckedBoxes();
      if (!checkedBoxes.length) return;

      removeSelectedButton.disabled = true;
      removeSelectedButton.setAttribute('aria-busy', 'true');
      if (addButton) addButton.disabled = true;

      try {
        await Promise.all(
          checkedBoxes.map((checkbox) => removeWishlistItem(checkbox.value)),
        );

        checkedBoxes.forEach((checkbox) => {
          checkbox.closest('[data-wishlist-card]')?.remove();
        });

        updateEmptyState();
      } catch (error) {
        root.dispatchEvent(
          new CustomEvent('topshelf:wishlist-error', {
            detail: {message: error instanceof Error ? error.message : 'Unable to remove selected items.'},
          }),
        );
        updateSelection();
      } finally {
        removeSelectedButton.removeAttribute('aria-busy');
      }
    });

    addButton?.addEventListener('click', () => {
      const variantIds = getCheckedAvailableBoxes()
        .map((checkbox) => getVariantId(checkbox.value))
        .filter(Boolean);

      if (!variantIds.length) return;

      window.location.href = `/cart/${variantIds.map((id) => `${id}:1`).join(',')}`;
    });

    root.addEventListener('topshelf:wishlist-error', (event) => {
      const message = root.querySelector('[data-wishlist-error]');
      if (!message) return;

      message.textContent = event.detail?.message || 'Something went wrong. Please try again.';
      message.hidden = false;
    });

    updateEmptyState();
  });
})();
